import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { Box, Button, Flex, Grid, IconButton } from '@chakra-ui/react';
import { EventEmitter, hasValue, useT } from '@progress-fe/core';
import { Svg } from '../../base';
import { Select } from '../../inputs';
import { useJsFieldFormData } from '../../../hooks';
import { JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-logical-elements" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TLogicalElementsFormData.
 */
const LogicalElementsJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const formData = structuredClone(props.formData);
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: formData?.fieldConfig || null,
        values: formData?.fieldValues || null,
        onChange: props.onChange
    });
    const { t } = useT();
    const isAllChosen = fieldConfig?.elements.length === fieldValues?.selected.length;
    const allOptions = () => {
        return fieldConfig?.elements.map((opt) => ({ value: opt.value, label: opt.label })) || [];
    };
    const filteredOptions = () => {
        const alreadySelected = fieldValues?.selected.map((s) => s.uuid).filter((s) => !!s) || [];
        return (fieldConfig?.elements
            .filter((e) => !alreadySelected.includes(e.value))
            .map((opt) => ({ value: opt.value, label: opt.label })) || []);
    };
    const handleOnChange = (option, index) => {
        if (!fieldValues)
            return;
        const fieldValuesCopy = structuredClone(fieldValues);
        fieldValuesCopy.selected[index].uuid = option.value;
        onChangeFieldValues(fieldValuesCopy);
    };
    const handleOnAdd = () => {
        if (!fieldValues)
            return;
        const fieldValuesCopy = structuredClone(fieldValues);
        fieldValuesCopy.selected.push({ uuid: null, relationType: null });
        onChangeFieldValues(fieldValuesCopy);
    };
    const handleOnDelete = (index) => {
        if (!fieldValues)
            return;
        const fieldValuesCopy = structuredClone(fieldValues);
        fieldValuesCopy.selected.splice(index, 1);
        onChangeFieldValues(fieldValuesCopy);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "LogicalElementsJsField-test", "data-name": props.name, children: _jsx(Flex, { pb: "2px", flexDirection: "column", gap: "4px", children: !hasValue(fieldConfig?.elements.length) ? (_jsx(Box, { borderRadius: "4px", border: "1px solid", borderColor: "border", children: _jsx(Flex, { h: "64px", alignItems: "center", justifyContent: "center", children: t('jsfields.LogicalElements.empty') }) })) : (_jsxs(Flex, { flexDirection: "column", gap: "4px", children: [fieldValues?.selected.map((selectedItem, index) => {
                            const selectedItemOption = allOptions().find((i) => i.value === selectedItem.uuid);
                            return (_jsxs(Grid, { gridTemplateColumns: "2fr 1fr 24px 24px", gap: "4px", children: [_jsx(Select, { name: `${index}-logical`, options: filteredOptions(), isDisabled: props.schema.readOnly, placeholder: t('common.notSelected'), value: selectedItemOption, onChange: (newValue) => {
                                            handleOnChange(newValue, index);
                                        } }), _jsx(Select, { name: `${index}-type`, isDisabled: true, options: [], placeholder: t('common.notSelected'), onChange: () => { } }), _jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: !hasValue(selectedItem.uuid), icon: _jsx(Box, { transform: "rotate(180deg)", children: _jsx(Svg, { size: "s12", name: "Back" }) }), onClick: () => {
                                            if (hasValue(selectedItem.uuid)) {
                                                EventEmitter.emit('SelectItem', selectedItem.uuid);
                                            }
                                        } }), _jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghost", isDisabled: props.schema.readOnly, icon: _jsx(Svg, { size: "s12", name: "Cross" }), onClick: () => handleOnDelete(index) })] }, `${selectedItem.uuid}`));
                        }), !props.schema.readOnly && !isAllChosen && (_jsx(Button, { size: "xs", variant: "ghost", onClick: () => handleOnAdd(), children: t('jsfields.LogicalElements.add') }))] })) }) }) }));
};
export const LogicalElementsJsField = memo(LogicalElementsJsFieldFC);
//# sourceMappingURL=LogicalElementsJsField.js.map